import { createReducer, on } from '@ngrx/store';
import { IAddressGroup } from '@core/models/address-group';
import {
  FinishAddressGroups,
  GetAddressGroups,
} from '@core/state/address-group/address-group.actions';

export interface AddressGroupState {
  addressGroups: IAddressGroup[];
  loading: boolean;
}

export const initialAddressGroupState: AddressGroupState = {
  addressGroups: [],
  loading: false,
};

export const addressGroupReducer = createReducer(
  initialAddressGroupState,
  on(GetAddressGroups, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(FinishAddressGroups, (state, { addressGroups }) => {
    return {
      ...state,
      loading: false,
      addressGroups,
    };
  })
);
